import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/sales/app/global-error.tsx");
